import { DataState } from "./data.reducer";
import { createSelector, createFeatureSelector } from "@ngrx/store";

export const selectDataState = createFeatureSelector<DataState>('dataReducer');

export const selectData = createSelector(selectDataState, (state: DataState) => state.data);

export const selectLeadResponse = createSelector(selectDataState, (state: DataState) => state.data ? state.data.LeadResponse : null);